export const officeTitle = 'Office for Reparations'
export const officeSubTitle = 'Sri lanka'
